import $ from "jquery";
import gsap from "gsap";
import EventEmitter from "eventemitter3";
import RankingManager from "./RankingManager";

type Model = {
  username: string;
  score: number;
};

/**
 * RankingViewクラス
 */
class RankingView extends EventEmitter {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //DOM
  private _container: JQuery;
  private _closeBtn: JQuery;
  private _wrapper: JQuery;
  private _list: JQuery;

  // ---------------------------------------------------------------------------------------------------------
  // --	RankingView
  // ---------------------------------------------------------------------------------------------------------
  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //DOM参照
    this._container = $("#ranking");
    this._closeBtn = $(".c-ranking__close-btn");
    this._wrapper = $(".c-ranking__wrapper");
    this._list = $(".c-ranking__list");

    //ボタンアクション
    this._closeBtn.on("click", (e) => {
      e.preventDefault();
      this.close();
    });

    //初期リセット
    this.reset();
  }

  /**
   * リセット
   **/
  reset() {
    //Tween停止
    gsap.killTweensOf(this._container);

    //初期非表示
    this._container.hide();
    gsap.set(this._wrapper, { y: "100%" });

    //リスト削除
    this._list.empty();
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
  // --	 開く
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * 開く
   **/
  open() {
    //コンテナ
    this._container.show();
    gsap.killTweensOf(this._wrapper);
    gsap.set(this._wrapper, { y: "100%" });
    gsap.to(this._wrapper, {
      duration: 0.6,
      y: "0%",
      ease: "power2.out",
      onComplete: this.showRanking.bind(this),
    });
  }

  /**
   * ランキング表示
   */
  showRanking() {
    //ランキング取得
    const results: any = RankingManager.instance.getRanking();

    //結果表示
    if (results) {
      //配列に格納して並び替え
      const models: Model[] = [];
      for (const key in results) {
        models.push(results[key]);
      }
      models.sort((a, b) => b.score - a.score);

      //モデルを描画
      let prevScore = -9999999999;
      let rank: number = 0;
      let len: number = models.length;
      for (let i = 0; i < len; i++) {
        //モデル取得
        const model = models[i];

        //ランク
        if (model.score != prevScore) {
          rank++;
          prevScore = model.score;
        }

        //表示
        this._container
          .find("ul")
          .append(
            '<li class="c-ranking__list-item"><div class="c-ranking__rank">' +
              rank +
              '</div><div class="c-ranking__name">' +
              model.username +
              '</div><div class="c-ranking__score">' +
              model.score +
              '<span class="c-ranking__unit">' +
              "m" +
              "</span></div></li>"
          );
      }
    }
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
  // --	 閉じる
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * 閉じる
   **/
  close() {
    //コンテナ
    gsap.killTweensOf(this._wrapper);
    gsap.to(this._wrapper, {
      duration: 0.6,
      y: "100%",
      ease: "power2.out",
      onComplete: () => {
        this.reset();
      },
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default RankingView;
